import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import { COMPANY_INFO } from '../data'

export default function NotFoundPage() {
  return (
    <div className="min-h-[75vh] bg-[#0f1013] text-[#f4f3f0] flex items-center justify-center py-16 px-4">
      <SEO
        title="404 - Siden blev ikke fundet | Docuit ink"
        description="Beklager, siden blev ikke fundet hos Docuit ink. Find vej tilbage til forsiden, galleriet eller book en tid."
      />

      <div className="max-w-xl w-full bg-[#17191e] border border-[#282b34] rounded-2xl p-8 sm:p-12 text-center shadow-2xl">
        <span className="text-6xl sm:text-7xl font-serif font-extrabold text-[#cbb05e] block mb-2">
          404
        </span>
        <h1 className="text-2xl sm:text-3xl font-serif font-bold text-white mb-3">
          Siden blev ikke fundet
        </h1>
        <p className="text-neutral-400 text-sm leading-relaxed mb-8">
          Beklager, den side du leder efter eksisterer desværre ikke eller er blevet flyttet. Du kan benytte knapperne herunder til at navigere videre.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#cbb05e] hover:bg-[#d8be65] text-[#0f1013] font-bold uppercase tracking-wider text-xs rounded transition-colors"
          >
            <i className="fa-solid fa-house" aria-hidden="true" />
            Gå til Forside
          </Link>

          <Link
            to="/galleri"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-neutral-900 border border-neutral-700 hover:border-neutral-500 text-white font-semibold uppercase tracking-wider text-xs rounded transition-colors"
          >
            <i className="fa-solid fa-images text-[#cbb05e]" aria-hidden="true" />
            Se Galleriet
          </Link>

          <Link
            to="/booking"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-neutral-900 border border-neutral-700 hover:border-neutral-500 text-white font-semibold uppercase tracking-wider text-xs rounded transition-colors"
          >
            Book tid
          </Link>
        </div>

        <div className="mt-8 pt-6 border-t border-neutral-800 text-xs font-mono text-neutral-400">
          Spørgsmål? Ring på <a href={`tel:${COMPANY_INFO.phoneRaw}`} className="text-[#cbb05e] whitespace-nowrap hover:underline">{COMPANY_INFO.phone}</a>
        </div>
      </div>
    </div>
  )
}
